/**
 * 接口地址的统一管理
 */
const base = {
  url: process.env.VUE_APP_BASE_API
}
export default {
  utils: {
    uploadFile: `${base.url}/proxy/util/uploadTemplate`
  },
  //账户概况
  accountAnalyseVn: {
    getData: `${base.url}/proxy/accountAnalyseVn/getData`,
    getAccountSurvey: `${base.url}/proxy/accountAnalyseVn/getAccountSurvey`,
    getDataActivate: `${base.url}/proxy/accountAnalyseVn/getDataActivate`,
    accountExport: `${base.url}/proxy/accountAnalyseVn/accountExport`,
    activateExport: `${base.url}/proxy/accountAnalyseVn/activateExport`
  },
  //存款概况
  chshinAnalyseVn: {
    getData: `${base.url}/proxy/chshinAnalyseVn/getData`,
    getDeposit: `${base.url}/proxy/chshinAnalyseVn/getDeposit`,
    depositExport: `${base.url}/proxy/chshinAnalyseVn/depositExport`,
    getDepositMoney: `${base.url}/proxy/chshinAnalyseVn/getDepositMoney`,
    depositMoneyExport: `${base.url}/proxy/chshinAnalyseVn/depositMoneyExport`
  },
  //取款概况
  chshoutAnalyseVn: {
    getData: `${base.url}/proxy/chshoutAnalyseVn/getData`,
    withdrawal: `${base.url}/proxy/chshoutAnalyseVn/withdrawal`,
    withdrawalExport: `${base.url}/proxy/chshoutAnalyseVn/withdrawalExport`,
    getPoorData: `${base.url}/proxy/chshoutAnalyseVn/getPoorData`,
    poor: `${base.url}/proxy/chshoutAnalyseVn/poor`,
    poorExport: `${base.url}/proxy/chshoutAnalyseVn/poorExport`
  },
  //交易概况
  realVn: {
    getData: `${base.url}/proxy/dealAnalyseVn/getData`,
    deal: `${base.url}/proxy/dealAnalyseVn/deal`,
    dealExport: `${base.url}/proxy/dealAnalyseVn/dealExport`,
    dealHand: `${base.url}/proxy/dealAnalyseVn/dealHand`,
    dealHandExport: `${base.url}/proxy/dealAnalyseVn/dealHandExport`,
    dealProduction: `${base.url}/proxy/dealAnalyseVn/dealProduction`,
    dealProductionExport: `${base.url}/proxy/dealAnalyseVn/dealProductionExport`
  },
  //代理设置
  adAgent: {
    rebateSetList: `${base.url}/proxy/adAgent/rebateSet/list`,
    rebateSetDel: `${base.url}/proxy/adAgent/rebateSet/del`,
    rebateSetEdit: `${base.url}/proxy/adAgent/rebateSet/edit`,
    rebateSetDetail: `${base.url}/proxy/adAgent/rebateSet/detail`,
    rebateSetStatus: `${base.url}/proxy/adAgent/rebateSet/status`,
    rebateSetListAll: `${base.url}/proxy/adAgent/rebateSet/listAll`,
    symbolList: `${base.url}/proxy/adAgent/symbol/list`,
    symbolEdit: `${base.url}/proxy/adAgent/symbolConf/edit`,
    symbolHistory: `${base.url}/proxy/adAgent/symbolConf/history`,
    personnelList: `${base.url}/proxy/adAgent/personnel/list`,
    personnelDel: `${base.url}/proxy/adAgent/personnel/del`,
    personnelEdit: `${base.url}/proxy/adAgent/personnel/edit`,
    personnelStatus: `${base.url}/proxy/adAgent/personnel/status`,
    personnelCascader: `${base.url}/proxy/adAgent/personnel/cascader`,
    customerLevelList: `${base.url}/proxy/adAgent/customerLevel/list`,
    customerList: `${base.url}/proxy/adAgent/customer/list`,
    customerUpdateInfo: `${base.url}/proxy/adAgent/customer/updateInfo`,
    customerStatistics: `${base.url}/proxy/adAgent/customer/statistics`,
    customerDown: `${base.url}/proxy/adAgent/customer/down`,
    customerApplyImport: `${base.url}/proxy/adAgent/customerApply/import`,
    customerApplyList: `${base.url}/proxy/adAgent/customerApply/list`,
    customerApplyStatus: `${base.url}/proxy/adAgent//customerApply/status`,
    customerApplyDel: `${base.url}/proxy/adAgent//customerApply/del`,
    levelList: `${base.url}/proxy/adAgent/level/list`,
    rebateLevel: `${base.url}/proxy/adAgent/rebate/levels`,
    agentRevenueSumStat: `${base.url}/proxy/adAgent/rebate/agent-revenue-sum`,
    rebateDetailList: `${base.url}/proxy/adAgent/rebatedetail/list`,
    rebateDetailTotal: `${base.url}/proxy/adAgent/rebatedetail/total`,
    rebateDetailDown: `${base.url}/proxy/adAgent/rebatedetail/down`,
    personnelApplyList: `${base.url}/proxy/adAgent/personnelApply/list`,
    personnelApplyStatus: `${base.url}/proxy/adAgent/personnelApply/status`,
    personnelApplyDel: `${base.url}/proxy/adAgent/personnelApply/del`,
    rebateMonthProvide: `${base.url}/proxy/adAgent/rebateMonth/provide`,
    rebateMonthList: `${base.url}/proxy/adAgent/rebateMonth/list`,
    excludeCustomers:`${base.url}/proxy/adAgent/exclude/list`,
    delExcludeCustomers:`${base.url}/proxy/adAgent/exclude/del`,
    saveExcludeCustomers:`${base.url}/proxy/adAgent/exclude/add`,
    creditLinePno:{
      list:`${base.url}/proxy/adAgent/creditPno/list`,
      edit:`${base.url}/proxy/adAgent/creditPno/edit`,
      reject:`${base.url}/proxy/adAgent/creditPno/reject`,
      apply:`${base.url}/proxy/adAgent/creditPno/apply`,
    },
    creditRecord:{
      list:`${base.url}/proxy/adAgent/creditRecord/list`,
    },
    customerCreditRecord:{
      list:`${base.url}/proxy/adAgent/customerCreditRecord/list`,
    },
    creditInfo:{
      list:`${base.url}/proxy/adAgent/creditInfo/list`,
      freeze:`${base.url}/proxy/adAgent/creditInfo/freeze`,
      unfreeze:`${base.url}/proxy/adAgent/creditInfo/unfreeze`,
    },
    settingPersonnels: `${base.url}/proxy/adAgent/setting/personnels`,
    settingEdit: `${base.url}/proxy/adAgent/setting/edit`,
    settingStatus: `${base.url}/proxy/adAgent/setting/status`,
  }
}
